import { render, staticRenderFns } from "./SuperSyndicateOverview.vue?vue&type=template&id=2b0208c5&scoped=true&"
import script from "./SuperSyndicateOverview.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicateOverview.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=2b0208c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0208c5",
  null
  
)

export default component.exports